document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('subscription_form');
    const progressBar = document.getElementById('progressbar');

    if (!form) {
        console.log('Subscription form not found. Script terminated.');
        return;
    }

    const variantInput = document.getElementById('variant-id');
    const sellingPlanInput = document.getElementById('selling-plan-id');
    let currentStep = 1;
    let isLoadingProductData = false;

    if (progressBar) initializeProgressBar();

    // Load initial product data if a plan is pre-selected
    const initialPlan = document.querySelector('input[name="product_plan"]:checked');
    if (initialPlan) {
        loadProductData(initialPlan.value).then(() => {
            updateSellingPlan();
            updateQuizVariants();
        });
    }

    function initializeProgressBar() {
        updateProgressBar(currentStep);
        updateStepActiveState(currentStep);
    }

    function updateProgressBar(step) {
        document.querySelectorAll('#progressbar .step').forEach((stepElem, index) => {
            stepElem.classList.toggle('active', index < step);
        });
    }

    function updateStepActiveState(step) {
        document.querySelectorAll('#progressbar .step').forEach(stepElem => {
            const stepIndex = parseInt(stepElem.getAttribute('data-step'), 10);
            stepElem.classList.toggle('active', stepIndex <= step);
        });
    }

    function navigateFieldset(forward = true) {
        const currentFs = document.querySelector(`fieldset:nth-of-type(${currentStep})`);
        const nextFs = forward ? currentFs?.nextElementSibling : currentFs?.previousElementSibling;

        if (!nextFs) return;

        currentFs.style.display = 'none';
        nextFs.style.display = 'block';
        currentStep = forward ? ++currentStep : --currentStep;

        updateProgressBar(currentStep);
        updateStepActiveState(currentStep);

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    document.querySelectorAll('.next').forEach(btn => btn.addEventListener('click', () => navigateFieldset(true)));
    document.querySelectorAll('.previous').forEach(btn => btn.addEventListener('click', () => navigateFieldset(false)));

    async function loadProductData(productHandle) {
        if (isLoadingProductData) return;

        try {
            isLoadingProductData = true;
            const response = await fetch(`/products/${productHandle}.json`);
            if (!response.ok) throw new Error('Failed to fetch product data');

            const data = await response.json();
            window.currentProduct = data.product;

            updateQuizVariants();
            updateAllPlanPrices(); // Call the function to update the prices
        } catch (error) {
            console.error('Error loading product data:', error);
        } finally {
            isLoadingProductData = false;
        }
    }

    function updateQuizVariants() {
        if (!window.currentProduct?.variants) return;

        const optionOne = document.querySelector('input[name="option_one"]:checked')?.value;
        const optionTwo = document.querySelector('input[name="option_two"]:checked')?.value;
        const optionThree = document.querySelector('input[name="option_three"]:checked')?.value;

        if (!optionOne || !optionTwo || !optionThree) return;

        const matchedVariant = window.currentProduct.variants.find(variant =>
            variant.option1 === optionOne &&
            variant.option2 === optionTwo &&
            variant.option3 === optionThree
        );

        if (matchedVariant) {
            variantInput.value = matchedVariant.id;
        }
    }

    // Define updateAllPlanPrices function to update the price for the correct plan
    function updateAllPlanPrices() {
        document.querySelectorAll('input[name="product_plan"]').forEach(async (plan) => {
            const productHandle = plan.value;

            try {
                const response = await fetch(`/products/${productHandle}.json`);
                if (!response.ok) throw new Error('Failed to fetch product data for plan');

                const productData = await response.json();
                const product = productData.product;

                const optionOne = document.querySelector('input[name="option_one"]:checked')?.value;
                const optionTwo = document.querySelector('input[name="option_two"]:checked')?.value;
                const optionThree = document.querySelector('input[name="option_three"]:checked')?.value;

                const matchedVariant = product.variants.find(variant =>
                    variant.option1 === optionOne &&
                    variant.option2 === optionTwo &&
                    variant.option3 === optionThree
                );

                if (matchedVariant) {
                    // Loop through each radio_option and update the price for the correct one
                    document.querySelectorAll(`.radio_option[data-product-handle="${productHandle}"]`).forEach((option) => {
                        const originalPriceElement = option.querySelector('.subscription-price');
                        const discountedPriceElement = option.querySelector('.subscription-discounted-price');
                        const discountPercentage = parseInt(option.getAttribute('data-discount'), 10);

                        if (originalPriceElement) {
                            originalPriceElement.textContent = `$${matchedVariant.price}`;
                        }
                      
                        if (discountedPriceElement && discountPercentage) {
                            const discountedPrice = (matchedVariant.price) * (1 - discountPercentage / 100);
                            discountedPriceElement.textContent = `$${discountedPrice.toFixed(2)}`;
                        }
                      
                    });
                }
            } catch (error) {
                console.error(`Error updating price for plan: ${productHandle}`, error);
            }
        });
    }

    function updateSellingPlan() {
        const selectedPlan = document.querySelector('input[name="product_plan"]:checked');
        if (selectedPlan) {
            sellingPlanInput.value = selectedPlan.getAttribute('data-plan-id') || '';
        }
    }

    // Fix: Force updates before validation during form submission
    form.addEventListener('submit', function (e) {
        updateQuizVariants();
        updateSellingPlan();

        if (!variantInput.value || !sellingPlanInput.value) {
            e.preventDefault();
            alert('Please complete all quiz steps before submitting.');
            console.log({
                variantInput: variantInput.value,
                sellingPlanInput: sellingPlanInput.value,
                isLoadingProductData,
            });
        }
    });

    document.querySelectorAll('input[name="product_plan"]').forEach(plan => {
        plan.addEventListener('change', async () => {
            const productHandle = plan.value;

            if (window.currentProduct?.handle === productHandle) {
                updateAllPlanPrices();
                updateSellingPlan();
                return;
            }

            await loadProductData(productHandle);
            updateSellingPlan();
        });
    });

    document.querySelectorAll('input[type="radio"]').forEach(radio => {
        radio.addEventListener('change', () => {
            const parentOption = radio.closest('.radio_option');
            if (parentOption) {
                parentOption.parentElement.querySelectorAll('.radio_option').forEach(option => option.classList.remove('active'));
                parentOption.classList.add('active');
            }

            updateQuizVariants();
            updateAllPlanPrices();
        });
    });

    // Scroll to top when clicking the next action button
    $("button.next.action-button, input.next.action-button").click(function() {
      $("html, body").animate({ scrollTop: 0 }, 500);
    });
  
    const step1NextButton = document.querySelector('fieldset#step_1_content button.next.action-button');
    if (step1NextButton) {
        step1NextButton.addEventListener('click', function () {
            const petNameInput = document.querySelector('input#dog-name');
            const petName = petNameInput.value.trim() || "Your Dog";
            document.querySelectorAll('span#dogName').forEach(span => span.textContent = petName);
        });
    }
});


// Add is-filled class to birthday select field if it has a value
document.addEventListener("DOMContentLoaded", function () {
  // Apply 'is-filled' on page load and dynamically handle select fields
  document.querySelectorAll('select.input__field').forEach(select => {
    if (select.value) select.classList.add('is-filled');

    select.addEventListener('change', function () {
      select.classList.toggle('is-filled', select.value !== "");
    });
  });
// Apply 'is-filled' on page load and dynamically handle input fields
document.querySelectorAll('input.input__field').forEach(input => {
  if (input.value) input.classList.add('is-filled');
    input.addEventListener('keyup', function () {
    input.classList.toggle('is-filled', input.value !== "");
    });
  });
});


// START DYNAMIC MESSAGES HERE
function updateMessage(selectedValue, type) {
    var messageBoxes = {
        box: "boxMessage",
        allergy: "allergyMessage",
    };

    var messages = {
        box: {
            "Light Chewer": "Soft plush & squeaky toys for gentle play!",
            "Moderate Chewer": "Durable rubber and tough, fluff-free plush for engaging, mess-free play!",
            "Tough Chewer": "Built for power chewers! Includes ultra-durable rubber & nylon toys."
        },
        allergy: {
            "Toys & Treats": "💙 All treats are 100% Canadian-made & pup-approved!",
            "Toys Only": "🐾 No treats? No problem! We’ve packed in extra toys instead!"
        }
    };

    // Define messageBox before using it**
    var messageBox = document.getElementById(messageBoxes[type]);

    // Add fade-out effect before changing text
    messageBox.classList.add("fade");

    setTimeout(function () {
        messageBox.innerHTML = messages[type][selectedValue] || "";
        messageBox.classList.remove("fade");
    }, 200);
}

// Auto-load messages for the default selections
document.addEventListener("DOMContentLoaded", function () {
    var defaultBox = document.querySelector("input[name='option_two']:checked");
    var defaultAllergy = document.querySelector("input[name='option_three']:checked");
    if (defaultBox) {
        updateMessage(defaultBox.value, "box");
    }
    if (defaultAllergy) {
        updateMessage(defaultAllergy.value, "allergy");
    }
});

// Ensure messages update dynamically when a new size or box type is selected
document.querySelectorAll("input[name='option_two']").forEach(function (radio) {
    radio.addEventListener("change", function () {
        updateMessage(this.value, "box");
    });
});
document.querySelectorAll("input[name='option_three']").forEach(function (radio) {
    radio.addEventListener("change", function () {
        updateMessage(this.value, "allergy");
    });
});
// END DYNAMIC MESSAGES HERE


document.addEventListener("DOMContentLoaded", function () {
  // Select the hidden input
  var promotionHidden = document.getElementById("promotion_hidden");

  // Function to update the promotion value
  function updatePromotion() {
    // Find the selected plan
    var selectedPlan = document.querySelector('input[name="product_plan"]:checked');
    
    if (selectedPlan) {
      // Get the promotion value from the selected radio button
      var promoValue = selectedPlan.getAttribute("data-promotion");

      // Update the hidden input field
      if (promotionHidden) {
        promotionHidden.value = promoValue || "";
      }
    }
  }

  // Run function on page load to ensure the correct default value is set
  updatePromotion();

  // Add event listeners to all plan radio buttons
  document.querySelectorAll('input[name="product_plan"]').forEach((radio) => {
    radio.addEventListener("change", updatePromotion);
  });
});